webpackJsonp([15],{

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export port */
/* unused harmony export host */
/* unused harmony export SERVER_TEST */
/* unused harmony export SERVER_ONLINE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_COURSE_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return WEB_URL_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COURSE_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COURSE_STUDY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAYMENT_SERVER; });
/* unused harmony export PAYMENT_SUBMIT */
/* unused harmony export isBrowser */
/* unused harmony export USER_CENTER_URL */
/* unused harmony export WAP_URL_INDEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOGIN_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BIND_PAGE; });
/* unused harmony export WAP_LOGIN_PAGE */
/* unused harmony export COURSE_LIST */
/* unused harmony export COURSE_LIST_WEB */
/* unused harmony export MY_COURSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LIVE_COURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LIVE_STUDY_COURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_DOWNLOAD_WAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADULT_STUDY_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return XBK_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return XBK_DOWNLOAD_LINK; });
/* unused harmony export VIRTUALMOBILE */
/* unused harmony export VIRTUALMOBILEONLINE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return VIRTUALNUMBERSERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOGIN_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return THIRD_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MOBILE_LOGIN_CONF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MAIL_LOGIN_CONF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_COOKIE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_base64__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_base64__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable max-len */



var port = process.env.PORT || 3000;
var host = process.env.WEBSITE_HOSTNAME || 'localhost:' + port;

var SERVER_TEST = 'https://xuetang-test-prod.youdao.com/course3/api/';
var SERVER_ONLINE = 'https://ke.youdao.com/course3/api/';

// client端使用的接口域名
var SERVER =  false ? SERVER_TEST : SERVER_ONLINE;
/**
 * 只有server端会注入process.env.API_SERVER 并优先使用该值,
 * 即在nodeserver端访问内网的ke-interval，该host没有ip限流
 * 线上状态下：
 *   1. 任何一个node端使用的接口都应该走ke-interval.youdao.com
 *   2. 在client端访问的接口都应走ke.youdao.com域名
 */
var API_SERVER = process.env.API_SERVER || SERVER;
var API_COURSE_SERVER =  false ? 'https://xuetang-test-prod.youdao.com/' : 'https://ke.youdao.com/';

var WEB_URL_INDEX =  false ? 'https://xuetang-test6.youdao.com' : 'https://ke.youdao.com';

var COURSE_DETAIL = API_COURSE_SERVER + 'course/detail/';
// export const COURSE_DETAIL = 'https://xuetang-test2.youdao.com/course/detail/'
// 云课堂课堂详情页地址

var COURSE_STUDY_DETAIL = 'https://ke.study.163.com/course/detail/';

var PAYMENT_SERVER = SERVER.replace('course3/api', 'course/app');
var PAYMENT_SUBMIT =  false ? 'https://ke.youdao.com/pay/ordersubmit/' : 'https://ke.youdao.com/pay/ordersubmit/';

var isBrowser = true;

var USER_CENTER_URL = 'https://kewap.youdao.com/user';
var WAP_URL_INDEX = 'https://ke.youdao.com/wap/';
var LOGIN_PAGE = WEB_URL_INDEX + '/login?back_url=';
var BIND_PAGE = WEB_URL_INDEX + '/user/bind/bindmobile?back_url=';
var WAP_LOGIN_PAGE = 'https://ke.youdao.com/wap/login';
var COURSE_LIST = 'https://kewap.youdao.com/m/course/list/0/1';
var COURSE_LIST_WEB = 'https://ke.youdao.com/m/course/list/0/1';
var MY_COURSE = 'https://ke.youdao.com/user/mycourse';
var LIVE_COURSE = 'http://live.youdao.com/live/index.html';
// 云课堂直播地址
var LIVE_STUDY_COURSE = 'https://live.study.163.com/live/index.html';
var APP_DOWNLOAD_WAP = 'https://c.youdao.com/xue/wap/appDownload.html';
// 云课堂成人教育域名
var ADULT_STUDY_SERVER = 'https://ke.study.youdao.com/';
// 获取小班课配置
var XBK_CONFIG =  false ? 'https://xbklivetest.youdao.com/api/v1/' : 'https://xblive.youdao.com/api/v1/';
var XBK_DOWNLOAD_LINK = 'https://codown.youdao.com/ke/pokeClass/2.0.1.0/YoudaoPokeClass-2.0.1.exe';
// 虚拟号
var VIRTUALMOBILE = 'https://xuetang-test3.youdao.com/';
var VIRTUALMOBILEONLINE = 'https://ke.youdao.com/';
var VIRTUALNUMBERSERVER =  false ? VIRTUALMOBILE : VIRTUALMOBILEONLINE;

// 登录验证接口(http or https)
var LOGIN_AUTH_URL =  false ? 'https://dict.youdao.com/login/acc' : 'https://dict.youdao.com/login/acc';
// 第三方登录配置
var THIRD_LOGIN = {
  qq: { name: 'qq', tp: 'cqq' },
  wb: { name: 'weibo', tp: 'tsina' },
  wx: { name: 'weixin', tp: 'weixin-web-xue' }
  // 网易手机号登录配置，参考wiki：http://doc.hz.netease.com/pages/viewpage.action?pageId=95165028
};var MOBILE_LOGIN_CONF = {
  // 全局配置
  // 产品ID,【必须】
  product: 'youdaodict',
  promark: 'MPWUAQf',
  // 滑块验证码的产品号,【必须】,注意大小写，产品必须同时接入滑块与图片验证码（hzzhouyoukai@corp.netease.com）
  productKey: 'a46c7d22ccc2da4b88e4bcb0c73870b6',
  version: 3,
  newCDN: 1,
  host: 'www.youdao.com', // 组件所在域名
  // 滑块验证码宽度,不能小于220，建议大点防止被破解,【必须】
  swidth: '320',
  isHttps: 1,
  // 邮箱登录，邮箱注册，手机帐号登录，手机帐号注册，锁定状态文案,【可选】
  lockConfig: {
    loginLockTxtMb: '登 录'
  },
  includeBox: 'mobileLogin', // 内嵌模式需要插入的Dom节点ID,【可选】
  domains: '163.com,126.com,vip.com,youdao.com', // 登录成功后要设置哪些域cookie
  cookieDomain: 'youdao.com', // 非163域名必选
  skin: 3,
  cssDomain: 'https://shared-https.ydstatic.com/', // 【可选】,自定义样式的地址，注意：必须是绝对路径，即含有完整的‘http：//’‘https://’协议头
  cssFiles: 'ke/login/20200701/weblogin.css', // 【可选】,自定义样式文件:使用样式覆盖方式进行样式自定义。强烈建议，css在head部分预先加载！
  single: 1,
  // 首屏,【可选】,注册:register，登录:login，根据实际情况填入.(此开关配合mobileFirst 可以确定首屏模块)
  page: 'login',
  customStyles: {
    imagePanel: {
      align: 'bottom' // 易盾在float模式下生效，指定imagePanel出现在controlBar上方还是下方。
    }
  },
  // 手机密码登录相关配置
  // 文案相关
  mbBtnTxt: '登 录', // 手机密码登录按钮文案,【可选】
  mobilePlaceholder: {
    mobile: '请输入手机号码', // 手机密码登录文案
    pwd1: '请输入密码' // 手机密码登录文案
  },
  // 配置
  needMobileLogin: 1, // 需要手机帐号登录模块,【可选】
  mobileFirst: 1, // 手机帐号相关模块优先展示,【可选】
  smsLoginFirst: 1, // 优先短信登录方式,【可选】
  mbNeedItl: 1, // 手机帐号登录和注册是否支持国际手机号,【可选】
  noqr: 1, // 设置手机帐号是否隐藏二维码登录,【可选】

  // 手机验证码登录+注册模块相关配置，统一在uniteLogin对象下
  uniteLogin: {
    loginTxt: '登 录', // 手机验证码登录按钮文案
    isItl: 1, // 是否国际号
    first: 1, // 是否统一登录是首屏
    needClause: 0, // 是否需要条款
    placeholders: {
      mob: '请输入手机号码',
      sms: '请输入验证码'
    }
  }
};

var MAIL_LOGIN_CONF = {
  product: 'youdaodict',
  promark: 'MPWUAQf',
  productKey: 'a46c7d22ccc2da4b88e4bcb0c73870b6',
  version: 3,
  newCDN: 1,
  host: 'www.youdao.com',
  swidth: '320',
  isHttps: 1,
  lockConfig: {
    loginLockTxtMb: '登 录'
  },
  includeBox: 'mailLogin',
  domains: '163.com,126.com,vip.com,youdao.com',
  cookieDomain: 'youdao.com',
  skin: 3,
  cssDomain: 'https://shared-https.ydstatic.com/',
  cssFiles: 'ke/login/20200701/weblogin.css',
  single: 1,
  page: 'login'

  // 支付方式
};var PayMode = {
  wechat: 'wechat',
  alipay: 'alipay'

  // 云课堂置换cookie中间页地址
};var SET_COOKIE_URL = 'https://study.youdao.com/passport/adult/changeCookiesWithNoDict.htm?single=false&returnUrl=';

/**
 * 跳转地址处理，跳转到云课堂页面前请调用该方法，先置换cookie
 * @param {String} url  跳转目标地址
 */
var getUrl = function getUrl(url) {
  // 提取域名
  var regexp = /^(https|http)?:\/\/[\w-.]+(:\d+)?/i.exec(url);
  var domain = void 0;

  if (regexp && regexp.length) {
    domain = regexp[0] || '';
  }

  if (!domain) {
    return url;
  }
  // 是不是云课堂的域名
  var isStudy = domain.includes('study.163');

  // 不是云课堂的域名
  if (!isStudy) {
    return url;
  }

  // 调置换cookie接口,往云课堂域写cookie
  return '' + SET_COOKIE_URL + __WEBPACK_IMPORTED_MODULE_0_js_base64__["Base64"].encode(url);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animateScrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkIEMode; });
/* unused harmony export addLogParam */
/* unused harmony export removeLogParam */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return trackEventLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatTime; });
/* unused harmony export bindStatusMsg */
/* harmony export (immutable) */ __webpack_exports__["e"] = dealMobile;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return back2Url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return originLoginType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(111);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var cx = function cx(params) {
  var cssStr = '';
  Object.keys(params).forEach(function (item) {
    if (params[item]) {
      cssStr += item + ' ';
    }
  });
  return cssStr.slice(0, -1);
};

var animateScrollTo = function animateScrollTo(el, val) {
  var cval = el.scrollTop;
  var dval = val - cval;
  var f = 30;
  var run = function run() {
    dval /= 2;
    if (Math.abs(dval) > 10) {
      cval += dval;
      el.scrollTop = cval; // eslint-disable-line
      window.setTimeout(run, f);
    } else {
      el.scrollTop = val; // eslint-disable-line
    }
  };
  run();
};

var checkIEMode = function checkIEMode(ua) {
  var ReMsie = /MSIE ([0-9]+)/;
  if (!ReMsie.test(ua)) return false;
  var m = ReMsie.exec(ua);
  if (!m) return false;
  var version = m[1];
  return parseInt(version, 10);
};

var addLogParam = function addLogParam(params) {
  if (!true || !window._rlog) return; // eslint-disable-line
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    window._rlog.push(['_addPost', key, val]); // eslint-disable-line
  });
};

var removeLogParam = function removeLogParam(keys) {
  if (!true || !window._rlog) return; // eslint-disable-line
  keys.forEach(function (key) {
    window._rlog.push(['_removePost', key]); // eslint-disable-line
  });
};

var trackEventLog = function trackEventLog(key, params) {
  if (!true || !window._rlog) return; // eslint-disable-line
  if (params) {
    addLogParam(params);
  }
  window._rlog.push(['_trackEvent', key]); // eslint-disable-line
  if (params) {
    removeLogParam(Object.keys(params));
  }
};

var formatTime = function formatTime(time) {
  var date = new Date(time);
  var month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
  var day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
  var hour = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
  var min = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
  return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + min;
};

var bindStatusMsg = function bindStatusMsg(code) {
  switch (code) {
    case 0:
      return '绑定成功';
    case 5:
      return '该账号已绑定';
    default:
      return '绑定失败';
  }
};

// 隐藏手机号中间四位
function dealMobile(num) {
  var replaceNum = null;
  if (num.indexOf('-') > -1) {
    replaceNum = num.replace(/(\+\d+-\d{3})(\d+)(\d{2})/, function (all, a, b, c) {
      return a + b.replace(/./g, '*') + c;
    });
  } else {
    replaceNum = num.replace(/(\d{3})\d{4}(\d{4})/, '$1 **** $2');
  }
  return replaceNum;
}

// 跳回到登录前页面
var back2Url = function back2Url(backurl) {
  if (/^http/.test(backurl)) {
    window.location.href = backurl;
  } else if (backurl.startsWith('/')) {
    window.location.href = '' + __WEBPACK_IMPORTED_MODULE_0__config__["t" /* WEB_URL_INDEX */] + backurl;
  } else {
    history.push(backurl || '/');
  }
};

var isMobile = function isMobile(str) {
  var mobilePattern = '^0*' + '(13|15|16|18|14|17|19)' + '(' + '\\d{9}|' + '\\d-\\d{3}-\\d{5}|' + '\\d-\\d{4}-\\d{4}|' + '\\d{2}-\\d{3}-\\d{4}|' + '\\d{2}-\\d{4}-\\d{3}' + ')$'; // 13800138000 // 138-001-38000 // 138-0013-8000 // 1380-013-8000 // 1380-0138-000
  var mobileRegExp = new RegExp(mobilePattern);
  if (!str) {
    return false;
  }
  return mobileRegExp.test(str);
};

var originLoginType = {
  cqq: 'QQ',
  tsina: 'sina',
  'weixin-web-xue': 'weixin',
  urstoken: 'mail'
};

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeActionCreator;
function makeActionCreator(type) {
  for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    argNames[_key - 1] = arguments[_key];
  }

  return function actioncreator() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var action = { type: type };
    argNames.forEach(function (arg, index) {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEST_PHONE_VIRTUAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_RUNTIME_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_BACK_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return HOME_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return HOME_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HOME_FETCH_MORE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HOME_FETCH_MORE_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HOME_SHOW_POP_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HOME_CLOSE_POP_UP; });
/* unused harmony export HOME_HIDE_SLIDE_NAV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_REMIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CANCEL_USER_REMIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LOG_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOG_OUT; });
/* unused harmony export USERS_BY_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SEARCH_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SEARCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SEARCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SEARCH_MORE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SEARCH_MORE_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_SEARCH_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TAG_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TAG_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TAG_FETCH_MORE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TAG_FETCH_MORE_END; });
/* unused harmony export TAG_CHANGE_TAB */
/* unused harmony export TAG_ENTRIES_STORAGE */
/* unused harmony export TALK_FETCH_START */
/* unused harmony export TALK_FETCH_END */
/* unused harmony export TALK_FETCH_MORE_START */
/* unused harmony export TALK_FETCH_MORE_END */
/* unused harmony export TALK_INIT */
/* unused harmony export TALK_CHANGE_TAB */
/* unused harmony export ADD_TALK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SERIAL_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SERIAL_FETCH_END; });
/* unused harmony export SERIAL_FETCH_MORE_START */
/* unused harmony export SERIAL_FETCH_MORE_END */
/* unused harmony export COURSE_FETCH_START */
/* unused harmony export COURSE_FETCH_END */
/* unused harmony export COURSE_COMMENT_FETCH */
/* unused harmony export SHOW_COURSE_DIALOG */
/* unused harmony export HIDE_COURSE_DIALOG */
/* unused harmony export ORDER_FETCH_START */
/* unused harmony export ORDER_FETCH_END */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MYCOURSE_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MYCOURSE_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MYCOURSE_DATA_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MYCOURSE_DATA_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MYORDER_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MYORDER_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTORDER_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADULTORDER_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ORDER_CANCEL_REASONS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BIND_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_BIND_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_LOGIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SERIALCOURSE_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SERIALCOURSE_FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUPON_COURSE_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_XBK_CONFIG; });
/* unused harmony export VALID_URL_REG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return QUALIFICATION; });
/* eslint-disable import/prefer-default-export */

var TEST_PHONE_VIRTUAL = 'TEST_PHONE_VIRTUAL';
var SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

var SET_BACK_URL = 'SET_BACK_URL';

var HOME_FETCH_START = 'HOME_FETCH_START';
var HOME_FETCH_END = 'HOME_FETCH_END';

var HOME_FETCH_MORE_START = 'HOME_FETCH_MORE_START';
var HOME_FETCH_MORE_END = 'HOME_FETCH_MORE_END';
var HOME_SHOW_POP_UP = 'HOME_SHOW_POP_UP';
var HOME_CLOSE_POP_UP = 'HOME_CLOSE_POP_UP';
var HOME_HIDE_SLIDE_NAV = 'HOME_HIDE_SLIDE_NAV';

var FETCH_USER_STATUS = 'FETCH_USER_STATUS';
var FETCH_USER_REMIND = 'FETCH_USER_REMIND';
var CANCEL_USER_REMIND = 'CANCEL_USER_REMIND';
var LOG_IN = 'LOG_IN';
var LOG_OUT = 'LOG_OUT';
var USERS_BY_MOBILE = 'USERS_BY_MOBILE';

// export const UNBIND_MOBILE = 'UNBIND_MOBILE'
// export const SET_TOAST_MSG = 'SET_TOAST_MSG'

var SEARCH_INIT = 'SEARCH_INIT';
var FETCH_SEARCH_START = 'FETCH_SEARCH_START';
var FETCH_SEARCH_END = 'FETCH_SEARCH_END';
var FETCH_SEARCH_MORE_START = 'FETCH_SEARCH_MORE_START';
var FETCH_SEARCH_MORE_END = 'FETCH_SEARCH_MORE_END';
var DELETE_SEARCH_HISTORY = 'DELETE_SEARCH_HISTORY';

var TAG_FETCH_START = 'TAG_FETCH_START';
var TAG_FETCH_END = 'TAG_FETCH_END';
var TAG_FETCH_MORE_START = 'TAG_FETCH_MORE_START';
var TAG_FETCH_MORE_END = 'TAG_FETCH_MORE_END';
var TAG_CHANGE_TAB = 'TAG_CHANGE_TAB';
var TAG_ENTRIES_STORAGE = 'TAG_ENTRIES_STORAGE';

var TALK_FETCH_START = 'TALK_FETCH_START';
var TALK_FETCH_END = 'TALK_FETCH_END';
var TALK_FETCH_MORE_START = 'TALK_FETCH_MORE_START';
var TALK_FETCH_MORE_END = 'TALK_FETCH_MORE_END';
var TALK_INIT = 'TALK_INIT';
var TALK_CHANGE_TAB = 'TALK_CHANGE_TAB';

var ADD_TALK = 'ADD_TALK';

var SERIAL_FETCH_START = 'SERIAL_FETCH_START';
var SERIAL_FETCH_END = 'SERIAL_FETCH_END';
var SERIAL_FETCH_MORE_START = 'SERIAL_FETCH_MORE_START';
var SERIAL_FETCH_MORE_END = 'SERIAL_FETCH_MORE_END';

var COURSE_FETCH_START = 'COURSE_FETCH_START';
var COURSE_FETCH_END = 'COURSE_FETCH_END';
var COURSE_COMMENT_FETCH = 'COURSE_COMMENT_FETCH';
var SHOW_COURSE_DIALOG = 'SHOW_COURSE_DIALOG';
var HIDE_COURSE_DIALOG = 'HIDE_COURSE_DIALOG';

var ORDER_FETCH_START = 'ORDER_FETCH_START';
var ORDER_FETCH_END = 'ORDER_FETCH_END';

var MYCOURSE_FETCH_START = 'MYCOURSE_FETCH_START';
var MYCOURSE_FETCH_END = 'MYCOURSE_FETCH_END';

var MYCOURSE_DATA_FETCH_START = 'MYCOURSE_DATA_FETCH_START';
var MYCOURSE_DATA_FETCH_END = 'MYCOURSE_DATA_FETCH_END';

var MYORDER_FETCH_END = 'MYORDER_FETCH_END';
var MYORDER_FETCH_START = 'MYORDER_FETCH_START';

var ADULTORDER_FETCH_START = 'ADULTORDER_FETCH_START';
var ADULTORDER_FETCH_END = 'ADULTORDER_FETCH_END';

var ORDER_CANCEL_REASONS_FETCH = 'ORDER_CANCEL_REASONS_FETCH';

var BIND_MOBILE = 'BIND_MOBILE';

var SET_BIND_STATUS = 'SET_BIND_STATUS';
var FETCH_LOGIN_INFO = 'FETCH_LOGIN_INFO';

var SERIALCOURSE_FETCH_START = 'SERIALCOURSE_FETCH_START';
var SERIALCOURSE_FETCH_END = 'SERIALCOURSE_FETCH_END';

var COUPON_COURSE_PACKAGE = 'COUPON_COURSE_PACKAGE'; // 套餐优惠券

var FETCH_XBK_CONFIG = 'FETCH_XBK_CONFIG';

var VALID_URL_REG = /^http[s]?:\/\/(\w*\.)*((163\.com)|(youdao\.com)|(ydstatic\.com)|(126\.com)|(huihui\.com))(:\d{2,5})?(\/.*)?$/;

var QUALIFICATION = [{
  name: '网易公司',
  url: 'http://www.163.com/'
}, {
  name: '隐私政策',
  url: 'http://c.youdao.com/xue/legal.html'
}, {
  name: '服务条款',
  url: 'http://c.youdao.com/xue/agreement.html'
}, {
  name: '中小学生校外培训服务合同',
  url: 'https://c.youdao.com/xue/k12contract.html'
}, {
  name: '有道精品课课程备案内容承诺书',
  url: 'https://c.youdao.com/xue/commitment.html'
}, {
  name: '公司证照',
  url: 'https://c.youdao.com/xue/license.html'
}];

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBindStatusEnd", function() { return setBindStatusEnd; });
/* harmony export (immutable) */ __webpack_exports__["setBindStatus"] = setBindStatus;
/* harmony export (immutable) */ __webpack_exports__["virtualMobileTest"] = virtualMobileTest;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBackUrlStatus", function() { return setBackUrlStatus; });
/* harmony export (immutable) */ __webpack_exports__["setBackUrl"] = setBackUrl;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logInEnd", function() { return logInEnd; });
/* harmony export (immutable) */ __webpack_exports__["logIn"] = logIn;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLoginInfoEnd", function() { return fetchLoginInfoEnd; });
/* harmony export (immutable) */ __webpack_exports__["fetchLoginInfo"] = fetchLoginInfo;
/* harmony export (immutable) */ __webpack_exports__["containCourse"] = containCourse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable import/prefer-default-export */

// import storage from '../core/storage';



// 设置绑定时的状态数据
var setBindStatusEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SET_BIND_STATUS */], 'data');
function setBindStatus(data) {
  return function setBindStatusAction(dispatch) {
    dispatch(setBindStatusEnd(data));
  };
}

// 检测虚拟号
function virtualMobileTest(phoneNumber) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var ds = _ref2.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ds.virtualMobileTest(phoneNumber);

            case 3:
              resp = _context.sent;
              _context.next = 6;
              return resp.json();

            case 6:
              data = _context.sent;
              return _context.abrupt('return', data);

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

              console.error('手机号检测异常,请确认手机号输入无误', _context.t0); // eslint-disable-line no-console
              // eslint-disable-next-line consistent-return
              return _context.abrupt('return', {});

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 10]]);
    }));

    function virtualMobileTestAction(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return virtualMobileTestAction;
  }();
}

/*
  登录类型存储到localstorage,主要用于验证是否为手机号登录
  {
    1:手机号登录
    2:邮箱登录
    4:第三方登录
  }
*/
// export function setMoStatus(num) {
//   return function setMoStatusAction() {
//     storage.save({
//       mo: num,
//     });
//   };
// }

/*
  登录状态存储到localstorage,主要用于第三方登录成功后的操作
  needbind,是否需要绑定.{0:不需要,1:需要（此时处于手机号已登录，绑定主账号未登录的状态,此状态下的登录页面不显示手机号登录组件）}
  thirdlogin,是否为第三方（微博、微信、qq）登录后的callback页面.{0:否,2:是}
  lostatus = needbind + thirdlogin.
  {
    0:非第三方登录后的callback页,不需要绑定
    1:非第三方登录后的callback页,需要绑定
    2:第三方登录后的callback页,不需要绑定
    3:第三方登录后的callback页,需要绑定
  }
*/
// export function setLoStatus(num) {
//   return function setLoStatusAction() {
//     storage.save({
//       lostatus: num,
//     })
//   }
// }

// 获取登录前的url地址
var setBackUrlStatus = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SET_BACK_URL */], 'backurl');
function setBackUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.host;

  return function setBackUrlAction(dispatch) {
    dispatch(setBackUrlStatus(url));
  };
}

// 手机号登录
var logInEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* LOG_IN */], 'data');
function logIn(cf) {
  var tp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'urs-phone-web';

  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref4) {
      var ds = _ref4.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return ds.login(cf, tp);

            case 3:
              resp = _context2.sent;
              _context2.next = 6;
              return resp.json();

            case 6:
              data = _context2.sent;
              return _context2.abrupt('return', data);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

              console.error('手机号登录异常，请稍后再试', _context2.t0); // eslint-disable-line no-console
              return _context2.abrupt('return', {});

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    function loginAction(_x6, _x7, _x8) {
      return _ref3.apply(this, arguments);
    }

    return loginAction;
  }();
}

// 查找使用过该手机号的用户信息（账号类型，昵称，头像）
// export const fetchUserInfoByMbEnd = creator(USERS_BY_MOBILE, 'data')
// export function fetchUserInfoByMb(mobile) {
//   return async function fetchUIBMAction(dispatch, getState, { ds }) {
//     try {
//       const resp = await ds.userinfoByMobile(mobile)
//       const data = await resp.json()
//       dispatch(fetchUserInfoByMbEnd(data))
//     } catch (error) {
//       console.log('查找使用过该手机号的用户信息异常，请稍后再试', error) // eslint-disable-line no-console
//     }
//   }
// }

// 设置toast信息
// export const setToastMsgEnd = creator(SET_TOAST_MSG, 'data')
// export function setToastMsg(data) {
//   return function setToastMsgAction(dispatch) {
//     dispatch(setToastMsgEnd(data))
//   }
// }

// 查询登录信息 http://luna.corp.youdao.com/index.php?title=AccountServer/co/cq
var fetchLoginInfoEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_LOGIN_INFO */], 'data');
function fetchLoginInfo() {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref6) {
      var ds = _ref6.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return ds.fetchLoginInfo();

            case 3:
              resp = _context3.sent;
              _context3.next = 6;
              return resp.json();

            case 6:
              data = _context3.sent;

              if (data.code === 0) {
                dispatch(fetchLoginInfoEnd(data.data));
              }
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              console.error('查找用户信息异常，请稍后再试', _context3.t0); // eslint-disable-line no-console

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 10]]);
    }));

    function fetchLoginInfoAction(_x9, _x10, _x11) {
      return _ref5.apply(this, arguments);
    }

    return fetchLoginInfoAction;
  }();
}

function containCourse() {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref8) {
      var ds = _ref8.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return ds.containCourse();

            case 3:
              resp = _context4.sent;
              _context4.next = 6;
              return resp.json();

            case 6:
              data = _context4.sent;

              if (!(data.code === 0)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt('return', data.data);

            case 9:

              console.error('containCourse:', data.msg);
              return _context4.abrupt('return', false);

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4['catch'](0);

              console.error('containCourse', _context4.t0); // eslint-disable-line no-console
              return _context4.abrupt('return', false);

            case 17:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 13]]);
    }));

    function fetchContainCourse(_x12, _x13, _x14) {
      return _ref7.apply(this, arguments);
    }

    return fetchContainCourse;
  }();
}

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (immutable) */ __webpack_exports__["searchInit"] = searchInit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSearchStart", function() { return fetchSearchStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSearchEnd", function() { return fetchSearchEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSearchMoreStart", function() { return fetchSearchMoreStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSearchMoreEnd", function() { return fetchSearchMoreEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteHistory", function() { return deleteHistory; });
/* harmony export (immutable) */ __webpack_exports__["deleteSearchHistory"] = deleteSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["fetchSearch"] = fetchSearch;
/* harmony export (immutable) */ __webpack_exports__["fetchSearchMore"] = fetchSearchMore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_storage__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





// 初始化
var init = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["E" /* SEARCH_INIT */], 'searchHistory');
function searchInit() {
  return function searchInitAction(dispatch) {
    var storageData = __WEBPACK_IMPORTED_MODULE_1__core_storage__["a" /* default */].load();
    dispatch(init(storageData ? storageData.searchHistory : null));
  };
}

var fetchSearchStart = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["k" /* FETCH_SEARCH_START */], 'item');
var fetchSearchEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* FETCH_SEARCH_END */], 'data');
var fetchSearchMoreStart = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* FETCH_SEARCH_MORE_START */], 'item', 'start');
var fetchSearchMoreEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* FETCH_SEARCH_MORE_END */], 'data');
var deleteHistory = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* DELETE_SEARCH_HISTORY */]);

function deleteSearchHistory() {
  return function deleteHistoryAction(dispatch) {
    dispatch(deleteHistory());
    __WEBPACK_IMPORTED_MODULE_1__core_storage__["a" /* default */].save({
      searchHistory: []
    });
  };
}

function fetchSearch(item) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var ds = _ref2.ds;

      var resp, _ref3, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchSearchStart(item));
              _context.prev = 1;
              _context.next = 4;
              return ds.historyResult(item);

            case 4:
              resp = _context.sent;
              _context.next = 7;
              return resp.json();

            case 7:
              _ref3 = _context.sent;
              data = _ref3.data;

              dispatch(fetchSearchEnd(data));
              __WEBPACK_IMPORTED_MODULE_1__core_storage__["a" /* default */].save({
                searchHistory: getState().search.searchHistory
              });
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0); // eslint-disable-line no-console

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 13]]);
    }));

    function fetchSearchAction(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return fetchSearchAction;
  }();
}

function fetchSearchMore(item, start) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref5) {
      var ds = _ref5.ds;

      var resp, _ref6, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchSearchMoreStart(item, start));
              _context2.prev = 1;
              _context2.next = 4;
              return ds.historyResultMore(item, start);

            case 4:
              resp = _context2.sent;
              _context2.next = 7;
              return resp.json();

            case 7:
              _ref6 = _context2.sent;
              data = _ref6.data;

              dispatch(fetchSearchMoreEnd(data));
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](1);

              console.log(_context2.t0); // eslint-disable-line no-console

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 12]]);
    }));

    function fetchSearchMoreAction(_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    }

    return fetchSearchMoreAction;
  }();
}

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * 本地存储方法
 */

var DATA_KEY = 'KEWEB_DATA';
var ls = global.localStorage;

var storage = {

  inited: false,
  data: {},

  init: function init() {
    this.inited = !this.inited;
    this.data = Object.assign({}, this.data, this.load());
    return this.data;
  },
  save: function save(data) {
    if (!this.inited) {
      this.init();
    }
    try {
      var newData = Object.assign({}, this.data, data);
      this.data = newData;
      ls.setItem(DATA_KEY, JSON.stringify(newData));
      return this.data;
    } catch (e) {
      return null;
    }
  },
  clean: function clean() {
    return ls.removeItem(DATA_KEY);
  },
  load: function load() {
    try {
      ls.setItem('supportStorage', true);
    } catch (e) {
      return null;
    }
    ls.removeItem('supportStorage');
    if (!this.inited) return this.init();

    return JSON.parse(ls.getItem(DATA_KEY) ? ls.getItem(DATA_KEY) : 'null');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (storage);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(351);
__webpack_require__(352);
module.exports = __webpack_require__(554);


/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__(555);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(203);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(346);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(646);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(647);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/history/PathUtils.js
var PathUtils = __webpack_require__(649);
var PathUtils_default = /*#__PURE__*/__webpack_require__.n(PathUtils);

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/index.js + 34 modules
var esm = __webpack_require__(655);

// EXTERNAL MODULE: ./node_modules/@sentry/integrations/esm/index.js + 11 modules
var integrations_esm = __webpack_require__(656);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(341);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./src/components/App.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */




var ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Integrate Redux
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: prop_types_default.a.shape({
    subscribe: prop_types_default.a.func.isRequired,
    dispatch: prop_types_default.a.func.isRequired,
    getState: prop_types_default.a.func.isRequired
  }).isRequired,
  // 需要给内部所有链接带上的参数
  fetch: prop_types_default.a.func,
  query: prop_types_default.a.object,
  urlGenerator: prop_types_default.a.func.isRequired
};

var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.

      return react_default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

App_App.childContextTypes = ContextType;

/* harmony default export */ var components_App = (App_App);
// EXTERNAL MODULE: ./src/core/logger.js
var core_logger = __webpack_require__(658);

// CONCATENATED MODULE: ./src/core/createFetch.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


function createFetch(fetch, _ref, sessionData) {
  var useragent = _ref.useragent,
      cookie = _ref.cookie,
      ie = _ref.ie;

  if (ie) {
    return function (url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            try {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                  json: function json() {
                    return JSON.parse(xhr.responseText);
                  }
                });
              }
              reject();
            } catch (e) {
              reject(e);
            }
          }
        };
        xhr.open('GET', url);
        xhr.setRequestHeader('Content-type', 'application/json');
        // xhr.setRequestHeader('Accept', 'application/json')
        // console.log('set timeout')
        xhr.timeout = 8000;
        xhr.send(null);
      });
    };
  }

  var options = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    referrerPolicy: 'no-referrer',
    credentials: 'include',
    mode: 'cors'
  };
  var headers = Object.assign({}, options.headers);
  if (false) {
    headers['user-agent'] = useragent;
    if (options.credentials === 'include') {
      headers.cookie = cookie;
    }
  }
  return function (url) {
    if (false) {
      logger.profile('fetch ' + url);
    }
    var req = fetch(url, Object.assign({}, options, {
      headers: headers
    }));
    return req.then(function (res) {
      if (false) {
        logger.profile('fetch ' + url);
      }
      // console.log(res.headers.get('set-cookie'))
      // console.log(sessionData)
      // eslint-disable-next-line
      if (sessionData && res.headers && res.headers._headers) sessionData.cookieArray = res.headers._headers['set-cookie'];
      return res;
    });
  };
}

/* harmony default export */ var core_createFetch = (createFetch);
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var es = __webpack_require__(205);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(804);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(25);

// CONCATENATED MODULE: ./src/reducers/download.js


function runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case constants["n" /* FETCH_XBK_CONFIG */]:
      return { download: action.download };
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/user.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function deleteByInx(array, inx) {
  var result = array.slice();
  result.splice(inx, 1);
  return result;
}

function user_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    status: {},
    remind: []
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["m" /* FETCH_USER_STATUS */]:
      return _extends({}, state, {
        status: action.data
      });
    case constants["l" /* FETCH_USER_REMIND */]:
      return _extends({}, state, {
        remind: action.data.result
      });
    case constants["d" /* CANCEL_USER_REMIND */]:
      return _extends({}, state, {
        remind: deleteByInx(state.remind, action.inx)
      });
    case constants["c" /* BIND_MOBILE */]:
      return _extends({}, state, {
        bindstatus: action.data
      });
    case constants["v" /* LOG_OUT */]:
      return _extends({}, state, {
        status: {}
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/runtime.js
var runtime__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function runtime_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case constants["L" /* SET_RUNTIME_VARIABLE */]:
      return runtime__extends({}, state, _defineProperty({}, action.payload.name, action.payload.value));
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/home.js
var home__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function home_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fixedEntries: [],
    head: [],
    layout: ['talk'],
    talk: { card: [], recommend: [] },
    inited: false,
    pop: false
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["p" /* HOME_FETCH_END */]:
      return home__extends({}, state, action.data, {
        inited: true
      });
    case constants["q" /* HOME_FETCH_MORE_END */]:
      return home__extends({}, state, {
        tagRecommends: state.tagRecommends.slice(4),
        tagRecommendCourses: state.tagRecommendCourses.concat(action.data.tagRecommendCourses)
      });
    case constants["t" /* HOME_SHOW_POP_UP */]:
      return home__extends({}, state, {
        pop: true
      });
    case constants["o" /* HOME_CLOSE_POP_UP */]:
      return home__extends({}, state, {
        pop: false
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/search.js
var search__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function addHistory(history, item) {
  if (!history) return [item];
  var inx = history.indexOf(item);
  if (inx === -1) {
    history.unshift(item);
  } else {
    history.splice(inx, 1);
    history.unshift(item);
  }
  if (history.length > 6) history.pop();
  return history;
}

function search() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    searchResult: {},
    searchResultHasMore: true,
    searchItem: '',
    isSearching: false,
    searchHistory: []
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["E" /* SEARCH_INIT */]:
      return search__extends({}, state, {
        searchHistory: action.searchHistory
      });
    case constants["k" /* FETCH_SEARCH_START */]:
      return search__extends({}, state, {
        isSearching: true,
        searchItem: action.item,
        searchHistory: addHistory(state.searchHistory, action.item)
      });
    case constants["h" /* FETCH_SEARCH_END */]:
      return search__extends({}, state, {
        isSearching: false,
        searchResult: action.data,
        searchResultHasMore: action.data.courses.length === 20
      });
    case constants["i" /* FETCH_SEARCH_MORE_END */]:
      return search__extends({}, state, {
        searchResult: {
          courses: state.searchResult.courses.concat(action.data.courses)
        },
        searchResultHasMore: action.data.courses.length === 20
      });
    case constants["f" /* DELETE_SEARCH_HISTORY */]:
      return search__extends({}, state, {
        searchHistory: []
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/tag.js
var tag__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function tag_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    inited: false,
    column: [],
    banner: [],
    courses: [],
    subTag: [],
    serial: []
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["M" /* TAG_FETCH_END */]:
      return tag__extends({}, action.data, {
        column: action.data.column || [],
        banner: action.data.banner || [],
        courses: action.data.courses || [],
        inited: true,
        hasMore: action.data.courses && action.data.courses.length >= 20,
        serial: action.data.serial || []
      });
    case constants["N" /* TAG_FETCH_MORE_END */]:
      return tag__extends({}, state, {
        courses: state.courses.concat(action.data.course),
        hasMore: action.data.course && action.data.course.length >= 10
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/mycourse.js
var mycourse__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/**
 * 我的课程数据混排-
 * 混排规则为： 第一页精品课数据，之后是云课堂数据，云课堂数据展示完再展示精品课数据
 * @param {Array} youdaoData  精品课课程
 * @param {Array} studyData   云课堂课程
 * @return {Array} courses    混排之后的课程
 */
var mixedCourse = function mixedCourse() {
  var youdaoData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var studyData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // 云课堂加上标识
  var sData = studyData.map(function (item) {
    return mycourse__extends({}, item, {
      isStudy: true
    });
  });
  var courses = [].concat(_toConsumableArray(youdaoData), _toConsumableArray(sData));
  return courses;
};

function mycourse_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    inited: false,
    hasMore: false,
    courses: [],
    isFetchMore: false
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["z" /* MYCOURSE_FETCH_START */]:
      return Object.assign({}, state, {
        isFetchMore: true
      });
    // eslint-disable-next-line no-case-declarations
    case constants["y" /* MYCOURSE_FETCH_END */]:
      var courses = [].concat(_toConsumableArray(state.courses)).concat(action.data);
      return {
        yCourses: action.data,
        hasMore: action.data && action.data.length >= 30,
        isFetchMore: false,
        inited: true,
        courses: courses
      };
    case constants["x" /* MYCOURSE_DATA_FETCH_START */]:
      return Object.assign({}, state, {
        isFetchMore: true
      });
    // eslint-disable-next-line no-case-declarations
    case constants["w" /* MYCOURSE_DATA_FETCH_END */]:
      var course = mixedCourse(action.youdaoData, action.studyData);
      return {
        courses: course,
        hasMore: action.youdaoData.length >= 30,
        isFetchMore: false,
        inited: true
      };
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/myorder.js


var myorder_initialState = {
  isFetchMore: false,
  hasAdultOrder: false,
  hasMore: false,
  list: [],
  nextList: [],
  cancelReasons: {}
};

function myorder_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : myorder_initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants["b" /* ADULTORDER_FETCH_START */]:
      return state;

    case constants["a" /* ADULTORDER_FETCH_END */]:
      return Object.assign({}, state, {
        hasAdultOrder: !!(action.data && action.data.length)
      });
    case constants["B" /* MYORDER_FETCH_START */]:
      return Object.assign({}, state, {
        isFetchMore: true
      });
    /**
     * 翻页过程中，需要知道下一页是否有数据以便知道下一页是否可点击：
     * 第一页加载数据（init）的时候：请求两次，0偏移量和10偏移量（一页10跳数据）。10偏移量存在数据说明有下一页。
     * 点击下一页（next）：请求下页数据去查验是否可以点击下一页，把之前请求好的数据nextList填入当前数据list中完成翻页数据变化。
     * 点击上一页（pre）：请求上一页数据直接请求两次，之所以没有用在点击下一页的时候存储list为preList，
     * 之后点击上一页拿preList去填充一个list的操作，是因为可能有连续点击上一页操作，造成没有提前预备好的preList。
     */
    case constants["A" /* MYORDER_FETCH_END */]:
      switch (action.change) {
        case 'next':
          return Object.assign({}, state, {
            nextList: action.data,
            list: state.nextList,
            hasMore: action.data.length > 0,
            isFetchMore: false
          });
        case 'pre':
        case 'init':
        default:
          return Object.assign({}, state, {
            list: action.data,
            nextList: action.list,
            hasMore: action.list.length > 0,
            isFetchMore: false
          });
      }
    case constants["C" /* ORDER_CANCEL_REASONS_FETCH */]:
      return Object.assign({}, state, {
        cancelReasons: action.data
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/login.js
var login__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function login_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    // bindshow: false,
    // needbind: false,
    backurl: '/',
    // mbloginstatus: {},
    // userinfobymb: [],
    // bindstatus: {},
    // unbindstatus: {},
    logininfo: {}
  };
  var action = arguments[1];

  switch (action.type) {
    // case SET_BIND_STATUS:
    //   return {
    //     ...state,
    //     ...action.data,
    //   }
    case constants["J" /* SET_BACK_URL */]:
      return login__extends({}, state, {
        backurl: action.backurl
        // case LOG_IN:
        //   return {
        //     ...state,
        //     mbloginstatus: action.data,
        //   }
        // case USERS_BY_MOBILE:
        //   return {
        //     ...state,
        //     userinfobymb: action.data.result.filter(
        //       item => !/^urs-phoneyd.*@163.com$/.test(item.userId),
        //     ),
        //   }
      });case constants["g" /* FETCH_LOGIN_INFO */]:
      return login__extends({}, state, {
        logininfo: action.data

        // case UNBIND_MOBILE:
        //   return {
        //     ...state,
        //     unbindstatus: action.data,
        //   }
        // case SET_TOAST_MSG:
        //   return {
        //     ...state,
        //     toastmsg: action.data,
        //   }
      });default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/serial.js
var serial__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function serial_runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    courses: [],
    serialInfo: {},
    hasMore: false,
    serial: [] // 通过 courseIds 检索出的系列课
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["F" /* SERIALCOURSE_FETCH_END */]:
      return serial__extends({}, state, {
        courses: action.rank !== 0 ? state.courses.concat(action.data.course) : action.data.course,
        serialInfo: action.data.serial || {},
        hasMore: action.data.course && action.data.course.length >= 10
      });
    case constants["H" /* SERIAL_FETCH_END */]:
      return Object.assign({}, state, {
        serial: action.data
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/course.js


function course_course() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    couponCoursePackages: null // 套餐优惠券对应的套餐信息
  };
  var action = arguments[1];

  switch (action.type) {
    case constants["e" /* COUPON_COURSE_PACKAGE */]:
      return Object.assign({}, state, {
        couponCoursePackages: action.couponCoursePackages
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js













/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
  download: runtime,
  user: user_runtime,
  home: home_runtime,
  search: search,
  tag: tag_runtime,
  runtime: runtime_runtime,
  mycourse: mycourse_runtime,
  myorder: myorder_runtime,
  login: login_runtime,
  serial: serial_runtime,
  course: course_course
}));
// EXTERNAL MODULE: ./src/store/createHelpers.js
var createHelpers = __webpack_require__(805);

// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(806);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js


function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js






function configureStore(initialState, helpersConfig) {
  var helpers = Object(createHelpers["a" /* default */])(helpersConfig);
  var middleware = [redux_thunk_es["a" /* default */].withExtraArgument(helpers)];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = es["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(es["d" /* createStore */])(reducers, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default)
      );
    });
  }

  return store;
}
// EXTERNAL MODULE: ./src/core/history.js
var core_history = __webpack_require__(342);

// EXTERNAL MODULE: ./src/actions/search.js
var actions_search = __webpack_require__(345);

// EXTERNAL MODULE: ./src/core/utils.js
var utils = __webpack_require__(204);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(111);

// CONCATENATED MODULE: ./src/core/urlGeneratorHelper.js


/**
 * 带上访问地址上的所有参数
 */
var urlGeneratorHelper_generateURL = function generateURL(originParams, url) {
  // console.log('generateURL', url, params)
  var params = void 0;
  if (originParams.noParam) {
    return Object(config["w" /* getUrl */])(url);
  }
  if (originParams.pdt) {
    params = originParams;
  } else {
    params = Object.assign({}, originParams, {
      Pdt: 'CourseWeb'
    });
  }
  var result = '';
  var keys = Object.keys(params);
  keys.forEach(function (key) {
    if (url.indexOf(key) === -1) {
      result = '' + result + key + '=' + params[key] + '&';
    }
  });
  result = result.slice(0, -1);

  if (!result) return url;
  if (url.indexOf('?') === -1) {
    var _str = url + '?' + result;
    // 云课堂url特殊处理
    return Object(config["w" /* getUrl */])(_str);
  }

  var str = url + '&' + result;
  // 云课堂url特殊处理
  return Object(config["w" /* getUrl */])(str);
};

/* harmony default export */ var urlGeneratorHelper = (function (params) {
  return function (url, extraParams) {
    return urlGeneratorHelper_generateURL(extraParams ? Object.assign({}, params, extraParams) : params, url);
  };
});
// EXTERNAL MODULE: ./node_modules/universal-router/browser.js
var browser = __webpack_require__(808);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./src/routes/user/index.js
var routes = [{
  path: '/mycourse',
  load: function load() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1261));
  }
}, {
  path: '/bind',
  children: [{
    path: '/',
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1262));
    }
  }, {
    path: '/(.*)bindmobile',
    load: function load() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1263));
    }
  }]
}, {
  path: '/order',
  load: function load() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1264));
  }
}];

/* harmony default export */ var user = (routes);
// CONCATENATED MODULE: ./src/routes/login/index.js
var login_routes = [{
  path: '/',
  load: function load() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1265));
  }
}, {
  path: '/mail',
  load: function load() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1266));
  }
}];

/* harmony default export */ var login = (login_routes);
// CONCATENATED MODULE: ./src/routes/pay/index.js
var pay_routes = [{
  path: '/wxwait/:itemId/:orderId/',
  load: function load() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1267));
  }
}];

/* harmony default export */ var pay = (pay_routes);
// CONCATENATED MODULE: ./src/routes/course/index.js
var course_routes = [{
  path: '/package', // 套餐
  children: [{
    path: '/coupon/:packageIds',
    load: function load() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1268));
    }
  }]
}];

/* harmony default export */ var routes_course = (course_routes);
// CONCATENATED MODULE: ./src/routes/serial/index.js
var serial_routes = [{
  path: '/coupon/:courseIds',
  load: function load() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1270));
  }
}, {
  path: '/:id',
  load: function load() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1271));
  }
}];

/* harmony default export */ var serial = (serial_routes);
// EXTERNAL MODULE: ./src/actions/login.js
var actions_login = __webpack_require__(344);

// CONCATENATED MODULE: ./src/routes/index.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
* Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// 需要立即跳转登录页的路由表,(有的页面不需要立刻跳登录页)
var pages = ['/user'];

// The top-level (parent) route
var routes_routes = {

  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [{
    path: '/',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1272));
    }
  }, {
    path: '/tag/:id',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1273));
    }
  },
  // {
  //   path: '/user/mycourse',
  //   load: () => import(/* webpackChunkName: 'mycourse' */ './mycourse'),
  // },
  {
    path: '/user',
    children: user
  }, {
    path: '/pay',
    children: pay
  },
  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: '/search/:wd',
    load: function load() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1274));
    }
  }, {
    path: '/login',
    children: login
  }, {
    path: '/download',
    load: function load() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1275));
    }
  }, {
    path: '/serial',
    children: serial
  }, {
    path: '/course',
    children: routes_course
  }, {
    path: '*',
    load: function load() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1276));
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next,
        store = _ref.store,
        query = _ref.query,
        pathName = _ref.pathName,
        urlGenerator = _ref.urlGenerator;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var logininfo, isLogin, phone, loginBack, result, route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch(Object(actions_login["fetchLoginInfo"])());

            case 2:
              logininfo = store.getState().login.logininfo;
              isLogin = logininfo.login, phone = logininfo.phone;
              loginBack = query.loginBack;

              // 登陆成功之后跳转

              if (!(isLogin && !Object(utils["g" /* isMobile */])(phone) && loginBack === 'true')) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return store.dispatch(Object(actions_login["containCourse"])());

            case 8:
              result = _context.sent;

              if (result) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('return', { // 重定向到绑定页
                redirect: '' + config["e" /* BIND_PAGE */] + encodeURIComponent(urlGenerator(pathName, {
                  loginBack: false
                }))
              });

            case 11:
              if (!(!isLogin && pages.find(function (p) {
                return pathName.startsWith(p);
              }))) {
                _context.next = 13;
                break;
              }

              return _context.abrupt('return', { // 重定向到登陆页
                redirect: '' + config["k" /* LOGIN_PAGE */] + encodeURIComponent(urlGenerator(pathName, {
                  loginBack: true
                }))
              });

            case 13:
              _context.next = 15;
              return next();

            case 15:
              route = _context.sent;

              // Provide default values for title, description etc.
              route.title = (route.title || 'Untitled Page') + ' - \u4E3A\u4F60\u7CBE\u9009\u597D\u8BFE';

              return _context.abrupt('return', route);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes_routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var src_routes = (routes_routes);
// CONCATENATED MODULE: ./src/router.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */




/* harmony default export */ var router = (new browser_default.a(src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return null;
  }
}));
// CONCATENATED MODULE: ./src/client.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location, action) {
    var curTime, grayStartTime, grayEndTime, filterStyle, route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            curTime = Date.now();
            grayStartTime = new Date(2020, 3, 4).getTime();
            grayEndTime = new Date(2020, 3, 5).getTime();
            filterStyle = window.location.pathname === '/' ? 'grayscale(1)' : 'unset';

            if (curTime > grayStartTime && curTime < grayEndTime) {
              document.documentElement.style.filter = filterStyle;
            }

            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            _context.prev = 8;
            _context.next = 11;
            return router.resolve(client__extends({}, context, {
              path: location.pathname,
              query: queryParams,
              pathName: location.pathname
            }));

          case 11:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt('return');

          case 14:
            if (!route.redirect) {
              _context.next = 17;
              break;
            }

            core_history["a" /* default */].replace(route.redirect);
            return _context.abrupt('return');

          case 17:

            appInstance = react_dom_default.a.render(_jsx(components_App, {
              context: context
            }, void 0, route.component), container, function () {
              return onRenderComplete(route, location);
            });
            _context.next = 26;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context['catch'](8);

            if (true) {
              _context.next = 24;
              break;
            }

            throw _context.t0;

          case 24:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[8, 20]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */










// import ErrorBoundary from './components/common/ErrorBoundary';








esm["a" /* init */]({
  dsn: 'https://3d5c2bfefa094a639e3e7562587f2ef0@jpksentry.youdao.com/9',
  integrations: [new integrations_esm["a" /* CaptureConsole */]({
    levels: ['error']
  })]
});

/* eslint-disable global-require */

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html

var ie = Object(utils["c" /* checkIEMode */])(window.navigator.userAgent);
var clientFetch = core_createFetch(self.fetch, {
  ie: ie
});
var queryParams = query_string_default.a.parse(location.search);
var clientStore = configureStore(window.App.state, {
  fetch: clientFetch,
  history: core_history["a" /* default */],
  originParams: queryParams
});
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: clientStore,
  fetch: clientFetch,
  query: queryParams,
  urlGenerator: urlGeneratorHelper(queryParams)
};

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    if (window.ga) {
      window.ga('send', 'pageview', Object(PathUtils["createPath"])(location));
    }
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = core_history["a" /* default */].location;core_history["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

clientStore.dispatch(Object(actions_search["searchInit"])());

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./router', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_winston__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_winston___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_winston__);


var level = process.env.LOG_LEVEL || 'debug';

var logger = new __WEBPACK_IMPORTED_MODULE_0_winston___default.a.Logger({
  transports: [new __WEBPACK_IMPORTED_MODULE_0_winston___default.a.transports.Console({
    level: level
    // timestamp: () => (new Date()).toISOString(),
  })]
});

/* unused harmony default export */ var _unused_webpack_default_export = (logger);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 763;

/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function generateParamsString(pathKey, params, useragent) {
  var userAgent = useragent || global.navigator.userAgent;
  var uaMatch = userAgent.match(/youdaodict\/([\d.]+)/);
  var keyFromParams = uaMatch && uaMatch[1] ? { keyfrom: 'deskdict.' + uaMatch[1] } : {};
  var param = Object.assign({}, params, {
    api_ver: '1.10.0', // tab服务版本参数
    api_version: '1.2', // 主站服务版本参数
    t: new Date().getTime()
  }, keyFromParams);
  if (global.debug) param.preview = true;
  var string = Object.keys(param).reduce(function (memo, key) {
    return '' + memo + key + '=' + param[key] + '&';
  }, '').slice(0, -1);
  if (pathKey.indexOf('?') !== -1) {
    string = pathKey + '&' + string;
  } else {
    string = '' + pathKey + (string ? '?' : '') + string;
  }
  // console.log(string)
  // if (!process.env.BROWSER) {
  //   return string.match(/^http(s)?:/) ? string : `${API_SERVER}${string}`;
  // }
  return string.match(/^http(s)?:/) ? string : '' + __WEBPACK_IMPORTED_MODULE_0__config__["c" /* API_SERVER */] + string;
}

function dsCreator(_ref) {
  var fetch = _ref.fetch,
      history = _ref.history,
      originParams = _ref.originParams,
      sessionData = _ref.sessionData;

  var request = function request(pathKey, params) {
    var req = fetch(generateParamsString(pathKey, Object.assign({}, params, originParams)));
    return req.then(function (res) {
      // console.log(res.headers.get('set-cookie'))
      // console.log(sessionData)
      // eslint-disable-next-line no-param-reassign
      if (sessionData) sessionData.cookie = res.headers.get('set-cookie');
      return res;
    });
  };

  var allRequests = {

    // 获取首页数据（ke.youdao.com/course3/api/webhome)
    home: function home() {
      return request('webhome');
    },

    // 首页加载更多
    homeMore: function homeMore(tagIds) {
      return request('webhome/recommendCourse', {
        tagIds: '[' + tagIds.join(',') + ']'
      });
    },

    // 用户登录
    login: function login(cf, tp) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/login?app=web&product=DICT&tp=' + tp + '&cf=' + cf + '&newjson=true&version=2.0');
    },
    // 退出登陆
    loginOut: function loginOut() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/se/reset?product=DICT&app=ke&newjson=true&version=2.0');
    },
    // 用户登录后信息
    fetchLoginInfo: function fetchLoginInfo() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/co/cq?product=DICT&cf=1&newjson=true&version=2.0');
    },
    // 账单中是否存在订单(登陆后判断是否需要跳绑定页用)
    containCourse: function containCourse() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/api/user/order/contains');
    },
    // 用户手机账号绑定
    bindMobile: function bindMobile() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/bind/special/bind?product=DICT&appname=ke&newjson=true&version=2.0');
    },
    // 强制用户手机账号绑定
    forceBindMobile: function forceBindMobile() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/bind/special/forceBind?product=DICT&appname=ke&newjson=true&version=2.0');
    },
    // 更新用户手机账号绑定
    updateBindMobile: function updateBindMobile() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/bind/changephone?product=DICT&appname=ke&newjson=true&version=2.0');
    },
    // 用户手机账号解绑定, 未使用
    unbindMobile: function unbindMobile() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* LOGIN_AUTH_URL */] + '/bind/unbindphone?product=DICT&appname=ke&newjson=true&version=2.0');
    },
    // 用户虚拟账号设置
    virtualMobileTest: function virtualMobileTest(mobile) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["s" /* VIRTUALNUMBERSERVER */] + 'checkMobile?mobile=' + mobile);
    },

    // 用户信息
    userStatus: function userStatus() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/user_status.jsonp');
    },
    userRemind: function userRemind() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/remind.json');
    },
    cancelRemind: function cancelRemind(hash) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/remind.json', {
        hash: hash
      });
    },

    // 垂直页初始化
    tag: function tag(id) {
      return request('vertical2', {
        tag: id
      });
    },

    // 垂直页加载更多
    tagMore: function tagMore(tag, rank) {
      return request('content/course', {
        tag: tag,
        rank: rank
      });
    },

    // 我的课程初始化
    mycourse: function mycourse(param) {
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/app/mycoursev3.json' + (param || '?&courseStatus=unexpire') + '&page=' + pageNum);
    },

    // 我的课程-云课堂的课程初始化
    mycourseStudy: function mycourseStudy(param) {
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* ADULT_STUDY_SERVER */] + 'course/app/mycoursev3.json' + (param || '?&courseStatus=unexpire') + '&page=' + pageNum);
    },

    // 我的订单
    myOrder: function myOrder() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["n" /* PAYMENT_SERVER */] + 'myOrder.json', {
        offset: offset,
        api_version: '1.14'
      });
    },
    // 迁移云课堂的成人订单
    adultOrder: function adultOrder() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* ADULT_STUDY_SERVER */] + 'course/app/myOrder.json', {
        offset: offset,
        api_version: '1.14'
      });
    },
    // 取消订单
    cancelOrder: function cancelOrder(orderId) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/order/cancel.json', {
        orderid: orderId
      });
    },
    // 问卷调查 0：支付成功 1:取消订单  http://luna.corp.youdao.com/index.php?title=%E5%AD%A6%E5%A0%82APP%E9%97%AE%E5%8D%B7%E8%B0%83%E6%9F%A5%E6%8E%A5%E5%8F%A3
    survey: function survey() {
      var surveyType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/survey/get.jsonp', { surveyType: surveyType });
    },
    surveySubmit: function surveySubmit() {
      var surveyType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var surveyId = arguments[1];
      var choice = arguments[2];
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/survey/submit.jsonp', {
        surveyType: surveyType,
        surveyId: surveyId,
        choice: choice
      });
    },
    // 根据订单ID查询物流信息
    getLogisticByOrderId: function getLogisticByOrderId(orderId) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/app/order/logistics.json?orderId=' + orderId);
    },

    // 课程详情页
    courseDetail: function courseDetail(courseId) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/api/detail.json?courseId=' + courseId);
    },

    courseComment: function courseComment(params, isHistory) {
      var commentUrl = isHistory ? __WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/comment/history.jsonp' : __WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/comment/list.jsonp';
      return request(commentUrl, params);
    },

    order: function order(id) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["n" /* PAYMENT_SERVER */] + 'order/detail.json', {
        id: id
      });
    },
    orderSubmit: function orderSubmit(orderId, payType) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["n" /* PAYMENT_SERVER */] + 'orderSubmit.json', {
        orderId: orderId,
        payType: payType
      });
    },

    historyResult: function historyResult(item) {
      return request('search', {
        q: encodeURIComponent(item),
        start: 0,
        offset: 20
      });
    },

    historyResultMore: function historyResultMore(item, start) {
      return request('search', {
        q: encodeURIComponent(item),
        start: start,
        offset: 20
      });
    },

    searchSuggest: function searchSuggest(item) {
      return request('suggest', {
        n: 5,
        q: item
      });
    },
    // 组合卡片系列课程详情
    serialCourse: function serialCourse(params) {
      return request('content/serialcourse', _extends({}, params));
    },

    // 通过课程 id 取系列课
    serial: function serial(courseIds) {
      return request('content/cards', {
        courseIds: courseIds
      });
    },

    // 支付相关
    // 继续支付
    payContinue: function payContinue(orderId, payType) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'course/app/orderSubmit.json', {
        orderId: orderId,
        payType: payType,
        payClient: 'WEB',
        wxTradeType: payType === 'wechat' ? 'NATIVE' : null
      });
    },

    // 订单相关
    // 微信wap支付轮询订单状态
    orderInfo: function orderInfo(orderId) {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* API_COURSE_SERVER */] + 'api/order/info/' + orderId + '.jsonp');
    },

    // 优惠券套餐: 套餐支持优惠券
    couponCoursePackage: function couponCoursePackage(packageIds) {
      return request('package/cards', {
        packageIds: packageIds
      });
    },

    xbkVersion: function xbkVersion() {
      return request(__WEBPACK_IMPORTED_MODULE_0__config__["u" /* XBK_CONFIG */] + 'getConfig');
    }
  };

  return {
    ds: allRequests,
    history: history
  };
}

/* harmony default export */ __webpack_exports__["a"] = (dsCreator);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ })

},[350]);


// WEBPACK FOOTER //
// client.12840a43e.js